<template lang="pug">
.redemption-code-container(@touchmove.prevent)
  .code-block
    .receive-packet-close(@click="closeModal")
      img.close(src="https://m.hellobike.com/resource/gallery/61/73dAyf7YZC.png?x-oss-process=image/quality,q_80")
    .receive-success {{successOver?'领取成功':'已领取的兑换码'}}
    .code-block-middle
      .code-title - 兑换码 -
      .code-code {{redemptionData.bonusThirdCode}}
      .code-time 使用有效期至 {{getTime()}}
    .btn-block(@click="goToUse") 复制并去兑换
  .shadow
</template>

<script>
import Clipboard from 'clipboard';
import Toast from '@/components/toast';
import { Navigator } from '@hb/h5-navigator';
import dayjs from 'dayjs';

export default {
  props: {
    successOver: {
      type: Boolean,
      default: false,
    },
    redemptionData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      clipboard: null,
    };
  },
  mounted() {
  },
  destroyed() {
    if (this.clipboard) {
      this.clipboard.destroy();
      this.clipboard = null;
    }
  },
  methods: {
    getTime() {
      if (this.redemptionData.propEndTime) {
        return dayjs(this.redemptionData.propEndTime).format('YYYY.MM.DD');
      }
      return '';
    },
    closeModal() {
      this.$emit('update:show', false);
    },
    goToUse() {
      this.closeModal();
      this.$nextTick(() => {
        this.clipboard = new Clipboard('.btn-block', {
          text: () => this.redemptionData.bonusThirdCode,
        });

        this.clipboard.on('success', () => {
          Toast.show('复制成功');
          Navigator.go(this.redemptionData.redirectUrl);
          this.clipboard.destroy();
        });

        this.clipboard.on('error', (e) => {
          e.clearSelection();
          this.clipboard.destroy();
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.redemption-code-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 222;

  .code-block {
    margin: 2.9rem auto 0;
    z-index: 101;
    position: relative;
    width: 3.2rem;
    height: 2.33rem;
    background: #fff;
    border-radius: 0.2rem;
    padding-top: 0.28rem;

    .receive-packet-close {
      position: absolute;
      top: 0.06rem;
      right: 0.1rem;

      .close {
        width: 0.16rem;
        height: 0.16rem;
        z-index: 101;
      }
    }

    .receive-success {
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-size: 0.18rem;
      font-weight: 500;
      text-align: center;
      margin: 0 auto;
    }

    .code-block-middle {
      width: 2.72rem;
      height: 0.92rem;
      color: #f7f9fa;
      border-radius: 0.02rem;
      margin: 0.1rem auto 0 auto;
      background: #f7f9fa;
      padding-top: 0.12rem;

      .code-title {
        text-align: center;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-size: 0.12rem;
        font-weight: 400;
        color: #5a6066;
      }

      .code-code {
        margin-top: 0.04rem;
        font-family: "DIN Alternate Bold", sans-serif;
        font-size: 0.22rem;
        font-weight: 700;
        text-align: center;
        color: #08f;
      }

      .code-time {
        margin-top: 0.04rem;
        text-align: center;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-size: 0.12rem;
        font-weight: 400;
        color: #5a6066;
      }
    }

    .btn-block {
      width: 2.88rem;
      height: 0.4rem;
      margin: 0.16rem auto 0 auto;
      border-radius: 0.05rem;
      background: #08f;
      color: #fff;
      text-align: center;
      line-height: 0.4rem;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-size: 0.16rem;
      font-weight: 500;
    }
  }

  .shadow {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
  }
}
</style>
